<template>
  <v-app>
    <Navbar :color="color" :flat="flat" />
    <v-main class="pt-0">
      <Inicio />
      <Gifs />
      <Formatos />
      <!-- <Beneficios /> -->
      <Testimonios />
      <Bonos
        :bonos="[
          'Plantillas optimizadas para tu taller',
          'Actualizaciones menores sin costo adicional',
          'Entrega del formato digital en menos de 72 horas',
          'Acceso exclusivo a tutoriales en video',
          'Soporte técnico prioritario vía WhatsApp',
          'Integración con software de facturación (opcional)',
          'Capacitación gratuita para el equipo de trabajo',
          'Personalización del formato con el logo de tu taller',
        ]"
      />
      <!-- <PricingSection /> -->
      <Faq
        :preguntas="[
          {
            pregunta:
              '¿Cómo recibo el formato de la Orden de Servicio Digital?',
            respuesta:
              'Recibirás un enlace único con las credenciales de acceso.',
          },
          {
            pregunta: '¿Necesito instalar algún programa?',
            respuesta:
              'No, el sistema es completamente en línea y accesible desde cualquier dispositivo con internet.',
          },
          {
            pregunta: '¿Qué pasa si necesito soporte técnico?',
            respuesta: 'Ofrecemos soporte vía WhatsApp',
          },
          {
            pregunta: '¿Puedo personalizar el formato con mi logo?',
            respuesta:
              'Sí, puedes agregar el logo de tu taller y ajustar algunos campos.',
          },
          {
            pregunta: '¿Cuánto tiempo tarda la entrega del formato?',
            respuesta:
              'Tu formato estará listo en menos de 72 horas después de la compra.',
          },
          {
            pregunta: '¿Las actualizaciones tienen costo?',
            respuesta:
              'Las actualizaciones menores son gratuitas; si hay mejoras grandes, ofrecemos descuentos exclusivos a clientes.',
          },
          {
            pregunta: '¿Puedo solicitar modificaciones especiales?',
            respuesta:
              'Sí, podemos adaptar el formato a tus necesidades con un costo adicional.',
          },
          {
            pregunta: '¿Qué métodos de pago aceptan?',
            respuesta:
              'Aceptamos transferencias bancarias y pagos en efectivo.',
          },
        ]"
      />
      <Contacto />
    </v-main>

    <!-- Botón flotante del temporizador (justo encima del botón de WhatsApp) -->
    <v-scale-transition>
      <v-btn
        fab
        dark
        fixed
        bottom
        right
        color="red"
        class="timer-btn"
        @click="$vuetify.goTo('#benefits')"
      >
        <span class="timer-text"
          >{{ remainingTime.minutes }}:{{ remainingTime.seconds }}</span
        >
      </v-btn>
    </v-scale-transition>

    <!-- Texto de "Aprovecha la oferta!" -->
    <v-scale-transition>
      <div class="offer-btn">
        <span class="offer-text">¡Aprovecha la oferta!</span>
      </div>
    </v-scale-transition>

    <!-- Botón WhatsApp -->
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        dark
        fixed
        bottom
        right
        color="secondary"
        :href="'https://wa.me/5214434846542'"
        target="_blank"
        class="mt-12"
      >
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
    </v-scale-transition>

    <!-- Botón de subir -->
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        left
        color="secondary"
        @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>

    <Footer />
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Inicio from "./components/Inicio";
import Gifs from "./components/Gifs";
import Formatos from "./components/Formatos";
import Beneficios from "./components/Beneficios";
import Contacto from "./components/Contacto";
import Testimonios from "./components/Testimonios.vue";
import PricingSection from "./components/PricingSection.vue";
import Bonos from "./components/Bonos.vue";
import Faq from "./components/Faq.vue";

export default {
  name: "App",

  components: {
    Navbar,
    Footer,
    Inicio,
    Gifs,
    Formatos,
    Beneficios,
    Faq,
    Bonos,
    Testimonios,
    PricingSection,
    Contacto,
  },

  data: () => ({
    fab: null,
    remainingTime: {
      minutes: 15,
      seconds: 0,
    },
    timer: null,
  }),

  mounted() {
    const storedTime = localStorage.getItem("remainingTime");
    if (storedTime) {
      this.remainingTime = JSON.parse(storedTime);
    } else {
      this.remainingTime = { minutes: 15, seconds: 0 };
    }
    this.startTimer();
  },

  beforeDestroy() {
    localStorage.setItem("remainingTime", JSON.stringify(this.remainingTime));
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if (this.remainingTime.seconds > 0) {
          this.remainingTime.seconds--;
        } else if (this.remainingTime.minutes > 0) {
          this.remainingTime.minutes--;
          this.remainingTime.seconds = 59;
        } else {
          clearInterval(this.timer); // Detener cuando llegue a cero
        }
        localStorage.setItem(
          "remainingTime",
          JSON.stringify(this.remainingTime)
        );
      }, 1000);
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style scoped>
.timer-btn {
  position: fixed;
  bottom: 80px; /* Posicionamos encima del botón de WhatsApp */
  right: 18px;
  z-index: 999;
  background-color: #9abe23; /* Color del temporizador */
  color: white;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.offer-btn {
  position: fixed;
  bottom: 140px; /* Ajustamos la posición para que no se sobrepongan */
  right: 10px;
  z-index: 999;
  color: rgb(0, 0, 0);
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 150px;
  height: 20px;
}

.offer-text {
  font-weight: bold;
  font-size: 0.9rem;
  text-align: center;
}

.v-main {
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}

.v-btn {
  transition: transform 0.3s ease-in-out;
}

.v-btn:hover {
  transform: scale(1.1);
}
</style>

<style>
/* Cambia el tamaño de la barra de desplazamiento */
::-webkit-scrollbar {
  width: 6px; /* Ancho de la barra de desplazamiento */
}

/* Cambia el color de la pista (fondo) */
::-webkit-scrollbar-track {
  background: transparent; /* Sin fondo visible */
}

/* Cambia el color del pulgar (parte que se mueve) */
::-webkit-scrollbar-thumb {
  background: #a2c334; /* Verde sutil */
  border-radius: 10px; /* Bordes redondeados */
}

/* Cambia el color del pulgar cuando pasa el ratón */
::-webkit-scrollbar-thumb:hover {
  background: #76a62f; /* Verde más oscuro cuando el mouse pasa por encima */
}
</style>
